/*
 * @Desc: prod环境配置文件
 * @Author: simbawu
 * @Date: 2019-06-05 10:37:24
 * @LastEditors: jiayi zhu
 */

module.exports = {
  HealthTask: 'https://record.boohee.com/',
  ExerciseCheck: 'https://nice.boohee.com/',
  AlibabaExerciseCheck: 'https://cube.boohee.com/',
  Lottery: 'https://one.boohee.com',
  Columbus: 'https://columbus.boohee.com',
  Passport: 'https://passport.boohee.com',
  Bingo: 'https://bingo.boohee.com',
  Status: 'https://status.boohee.com',
  qiniu_host: 'https://one.boohee.cn/',
  Crm: 'https://crm.boohee.com/',
  Longan: 'https://longan.boohee.com/',
  League: 'https://league.boohee.com/',
  CONFIG_WATER: {
    app_key: 'b257857e4b66bb887dd9d790',
    app_secret: '9f0acaff898d16a746a441dddaa7be9a',
    host: 'https://water.boohee.com/'
  },
  CALORY_HOST: 'https://calory.boohee.com/',
  PIXIU_HOST: 'https://pixiu.boohee.com/',
  FOODIE_HOST: 'https://foodie.boohee.com/',
  SA_SERVER_URL: 'https://saapi.boohee.cn/sa?project=production',
  SEAFARER_HOST: 'https://seafarer.boohee.com',
  GENE_BIND: 'https://healthy.boohee.com/',
  TRUCK_HOST: 'https://truck.boohee.com/',
  Bee: 'https://bee.boohee.com/',
  Gpt: 'https://gpt-core.boohee.com/',
  LLM: 'https://llm.boohee.com/',
  BOX_CRON: 'https://box-core.boohee.com/',
  DataInterface: 'https://api.boohee.com/data-interface/',
  APPInterface: 'https://api.boohee.com/app-interface/',
  MEMBER_HOST: 'https://member.boohee.com/',
  api: 'https://api.boohee.com',
  REPORT_URL:
    'https://front-report.boohee.cn/open-interface/v1/base/front-log-report'
};
